import type { Configuration } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AAD_CLIENT_ID as string,
    authority: import.meta.env.VITE_AAD_AUTHORITY as string,
    redirectUri: import.meta.env.VITE_AAD_REDIRECT_URI as string,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
const aadScopes = import.meta.env.VITE_AAD_SCOPES as unknown

export const loginRequest = {
  scopes: typeof aadScopes === 'string' ? aadScopes.split(',') : [],
}
